if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        this.querySelector('[role="document"]').classList.remove('is-zoomed');
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.setupLightbox();
        this.showActiveMedia();
      }

      get images() {
        return Array.from(this.querySelectorAll('[role="document"] > img[data-media-id]'));
      }

      setupLightbox() {
        const container = this.querySelector('[role="document"]');
        // photos only: keep Dawn's stacked layout if the product has video or 3D models
        if (container.children.length !== this.images.length) return;
        this.lightbox = true;
        container.setAttribute('data-lightbox', '');
        if (this.nav) return;

        const dialog = this.querySelector('.product-media-modal__dialog');
        const arrow = (cls, label, glyph, step) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = `product-media-modal__arrow ${cls}`;
          b.setAttribute('aria-label', label);
          b.textContent = glyph;
          b.addEventListener('click', () => this.step(step));
          return b;
        };
        this.counter = document.createElement('span');
        this.counter.className = 'product-media-modal__counter';
        this.counter.setAttribute('aria-live', 'polite');
        this.nav = document.createElement('div');
        this.nav.className = 'product-media-modal__nav';
        this.nav.append(arrow('is-prev', 'Previous photo', '\u2039', -1), this.counter, arrow('is-next', 'Next photo', '\u203A', 1));
        container.after(this.nav);
        if (this.images.length < 2) this.nav.hidden = true;

        // clicking the photo or the arrows must not count as "click outside" (which closes the modal); the backdrop still does
        this.addEventListener(
          'pointerup',
          (e) => {
            if (e.target.closest('img, .product-media-modal__nav')) e.stopPropagation();
          },
          true
        );

        // click / tap toggles zoom; when zoomed on desktop, moving the mouse pans the photo
        container.addEventListener('click', (e) => {
          if (e.target.tagName !== 'IMG') return;
          container.classList.toggle('is-zoomed');
          if (container.classList.contains('is-zoomed')) {
            container.scrollLeft = (container.scrollWidth - container.clientWidth) / 2;
            container.scrollTop = (container.scrollHeight - container.clientHeight) / 2;
          }
        });
        container.addEventListener('mousemove', (e) => {
          if (!container.classList.contains('is-zoomed')) return;
          container.scrollLeft = (e.clientX / container.clientWidth) * (container.scrollWidth - container.clientWidth);
          container.scrollTop = (e.clientY / container.clientHeight) * (container.scrollHeight - container.clientHeight);
        });

        // swipe + keyboard to browse
        let startX = null;
        container.addEventListener('touchstart', (e) => {
          startX = container.classList.contains('is-zoomed') || e.touches.length > 1 ? null : e.touches[0].clientX;
        }, { passive: true });
        container.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 50) this.step(dx < 0 ? 1 : -1);
          startX = null;
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.step(1);
          if (e.key === 'ArrowLeft') this.step(-1);
        });
      }

      step(direction) {
        const imgs = this.images;
        const current = imgs.findIndex((img) => img.classList.contains('active'));
        const next = imgs[(current + direction + imgs.length) % imgs.length];
        this.activate(next);
      }

      activate(media) {
        const container = this.querySelector('[role="document"]');
        this.querySelectorAll('[data-media-id].active').forEach((el) => el.classList.remove('active'));
        media.classList.add('active');
        container.classList.remove('is-zoomed');
        container.scrollTo(0, 0);
        if (this.counter) this.counter.textContent = `${this.images.indexOf(media) + 1} / ${this.images.length}`;
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        if (this.lightbox) {
          this.activate(activeMedia);
          return;
        }
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
